import request from '@/utils/request'


// 首页
export function home() {
  return request({
    url: 'home',
    method: 'get'
  })
}
// 关于我们
export function getAbout(id) {
  return request({
    url: 'about/' + id,
    method: 'get'
  })
}
export function getProduct(id) {
  return request({
    url: 'product/' + id,
    method: 'get'
  })
}

export function getProductInfo(id) {
  return request({
    url: 'productinfo/' + id,
    method: 'get'
  })
}

export function getNews(id) {
  return request({
    url: 'news/' + id,
    method: 'get'
  })
}

export function postFrom(data) {
  return request({
    url: 'postfrom',
    method: 'post',
    data: data
  })
}

export function postPlist(data) {
  return request({
    url: 'postlist',
    method: 'post',
    data: data
  })
}



